import React, { useState } from "react";
import { Props } from "react-select";
import { RouteDefine } from "../../routes/RouteDefine";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Navbar: React.FC<Props> = () => {
    let urlPath = window.location.pathname;
    const [stateUrl, setStateUrl] = useState(window.location.pathname);
    const { t } = useTranslation();

    return <React.Fragment>
        <div className="app-menu navbar-menu">
            <div id="scrollbar">
                <div className="container-fluid">
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="nav-item">
                            <Link to={RouteDefine.order}
                                  onClick={()=>setStateUrl(RouteDefine.order)}
                                  className={"nav-link menu-link menu-link-ams fs-14" + (RouteDefine.order === stateUrl ? ' active' : '')}>Payment Links</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={RouteDefine.payment}
                                  onClick={()=>setStateUrl(RouteDefine.payment)}
                                  className={"nav-link menu-link menu-link-ams fs-14" + (RouteDefine.payment === stateUrl ? ' active' : '')}>Payments</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={RouteDefine.business}
                                  onClick={()=>setStateUrl(RouteDefine.business)}
                                  className={"nav-link menu-link menu-link-ams fs-14" + (RouteDefine.business === stateUrl ? ' active' : '')}>Configuration</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={RouteDefine.document}
                                  onClick={
                                (e)=>{
                                    e.preventDefault(); // Ngăn không cho `<Link>` xử lý navigation
                                    window.open(RouteDefine.document, '_blank', 'noopener,noreferrer');
                                    // setStateUrl(RouteDefine.document);
                                }}
                                  className={"nav-link menu-link menu-link-ams fs-14" + (RouteDefine.document === stateUrl ? ' active' : '')}>Document</Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className={"nav-link menu-link menu-link-ams " + ((RouteDefine.order === urlPath || RouteDefine.customer === urlPath || RouteDefine.product === urlPath)
                                ? ' active' : '')} to={RouteDefine.order}>
                                <span data-key="t-home" className="fs-14">{t("common.navbar.shippingManagement")}</span>
                            </Link>
                            <div className="menu-dropdown p-0">
                                <ul className="nav nav-sm flex-column">
                                    <li className={`nav-item ${stateUrl === RouteDefine.order ? ' active' : ''}`}
                                        onClick={() => {
                                            setStateUrl(RouteDefine.order)
                                        }}
                                    >
                                        <Link className={'nav-link fs-14 justify-content-center bd-bottom'} to={RouteDefine.order}>{t("common.navbar.orders")}</Link>
                                    </li>
                                    <li className={`nav-item  ${stateUrl === RouteDefine.product ? ' active' : ''}`}
                                        onClick={() => {
                                            setStateUrl(RouteDefine.product)
                                        }}
                                    >
                                        <Link className={'nav-link fs-14 justify-content-center bd-bottom'} to={RouteDefine.product}>{t("common.navbar.products")}</Link>
                                    </li>
                                    <li className={`nav-item ${stateUrl === RouteDefine.customer ? ' active' : ''}`}
                                        onClick={() => {
                                            setStateUrl(RouteDefine.customer)
                                        }}
                                    >
                                        <Link className={'nav-link fs-14 justify-content-center bd-bottom'} to={RouteDefine.customer}>{t("common.navbar.customers")}</Link>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                        {/* end Dashboard Menu */}
                        {/* <li className="nav-item">
                            <Link to={RouteDefine.business} className="nav-link menu-link menu-link-ams fs-14">{t("common.navbar.settings")}</Link>
                        </li> */}
                        {/* <li className={"nav-item"}>
                            <Link
                                to={RouteDefine.shipment}
                                className={"nav-link menu-link menu-link-ams fs-14" + (RouteDefine.shipment === urlPath ? ' active' : '')}
                            >
                                {t("common.navbar.shippedInformation")}
                            </Link>
                        </li> */}
                        {/* end Dashboard Menu */}
                    </ul>
                </div>
                {/* Sidebar */}
            </div>
            <div className="sidebar-background" />
        </div>
    </React.Fragment>;
};
export default Navbar;
